import textPlugin from './text';
import buttonPlugin from './button';

export {
  textPlugin,
  buttonPlugin
};

export default [textPlugin, buttonPlugin];